var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.$attrs,false),[(!_vm.empty)?[_vm._t("default"),_vm._t("post")]:_vm._e(),(_vm.empty)?_c('div',{staticClass:"skeleton"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }